module.exports = __webpack_public_path__ + "fonts/SUIT-ExtraLight.0538bbd7.woff2";